import styled from 'styled-components'
import { themeV2 } from '@taglivros/tag-components'

import { BREAKPOINT } from '../../constants'

const GRID_BORDER_COLOR = 'TAG1-100'

export const Container = styled.div`
  padding: 32px 16px 16px;
  justify-content: center;
  display:flex;
  flex-direction: column;
  align-items: center;

  @media(min-width: ${BREAKPOINT.lg}) {
    padding: 32px;
  }
`
export const HeaderIconContainer = styled.div`
  max-width: 120px;
  max-height: 120px;
  margin: 0 auto 32px;
`
export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-bottom: 32px;
`
export const GridContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 12px;
`

export const SubscriptionGrid = styled.div`
  border: 1px solid ${themeV2.palette[ GRID_BORDER_COLOR ]};
  border-radius: 16px;
  display: grid;
  gap: 0px;

  @media (max-width: 667px) {
    max-width: 334px;
    grid-template-columns: repeat(1, minmax(328px, 334px));

    div:nth-child(2n).card {
      border-top: 1px solid ${themeV2.palette[ GRID_BORDER_COLOR ]};
      border-radius: 0
    }
  }

  @media (min-width: 668px) {
    grid-template-columns: repeat(2, minmax(328px, 334px));
    div:nth-child(2n).card {
      border-left: 1px solid ${themeV2.palette[ GRID_BORDER_COLOR ]};
      border-radius: 0
    }
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
`
